module.exports = __webpack_public_path__ + "img/18-2.00ea8762.jpg";